import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import CompanySubscriptionModal from "../../components/CompanySubscriptionModal";
import Select from 'react-select';
import { thisBaseURL } from "../../utils/helper.js";

let availableFoods = [];
let subscriberFoods = [];
let accessibleFoods = [];
let foodOptions = [];
let photoFilePath = "";
let photoFileName = "";
let defaultSlug = "";
let defaultFoodName = "";

const foodStyles = {
	control: styles => ({
		...styles, backgroundColor: 'white', borderRadius: '10px',
		lineHeight: '25px', minHeight: '30px', height: '35px', fontSize: '16px', verticalAlign: 'middle'
	}),
	option: (styles, state) => {
		return {
			...styles,
			lineHeight: '25px', height: '35px', fontSize: '16px',
			fontWeight: state.isSelected ? "bold" : "normal",
		};
	},
	singleValue: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '35px', fontSize: '16px', marginTop: '4px',
	}),
	indicatorSeparator: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px', marginTop: '0px',
	}),
	indicatorContainer: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px', marginTop: '4px',
	}),
	indicatorsContainer: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px', marginTop: '4px',
	}),
	container: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '35px', fontSize: '16px', whiteSpace: 'nowrap',
	}),
	input: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px',
	}),
	placeholder: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px', marginTop: '0px',
	}),
}
const defaultTop = 110;
function LeftMenu({ canRead, foodAnswers, foodList, defaultFoodId }) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [showSubMsg, setShowSubMsg] = useState(false);
	const [foodLoaded, setFoodLoaded] = useState(false);
    const [scrollTop, setScrollTop]=useState(0);

	useEffect(() => {
		setFoodValues(foodList);
		window.addEventListener('scroll',handleFoodScroll);
       return () => {
          window.removeEventListener('scroll',handleFoodScroll);
       };
	}, []);

	function setFoodValues(foodObj) {
		photoFilePath = "";
		photoFileName = "";
		defaultSlug = "";
		defaultFoodName = "";
		let foodOptionValue = {};
		let label = '';
		foodOptions = [];
		if (foodObj && foodObj.length > 0) {
			foodObj.map((food, index) => {
				if (food.published && (food.statusCode === 1)) {
					label = food.foodName;
					availableFoods.push(food.foodId);
					if (food.requireSubscription && !canRead) {
						label = food.foodName + ' $';
						subscriberFoods.push(food.foodId);
					}
					if (canRead) {
						accessibleFoods.push(food.foodId);
					}
					if (food.foodId === defaultFoodId) {
						photoFilePath = food.photoFilePath;
						photoFileName = food.photoFileName;
						defaultSlug = food.slug;
						defaultFoodName = food.foodName;
					}
					foodOptionValue.label = label;
					foodOptionValue.value = food.foodId;
					foodOptions.push(foodOptionValue);
					foodOptionValue = {};
				}
			});
		}
		setFoodLoaded(true);
	}
	function subscribePopupMsg(display) {
		if (display) {
			document.getElementById("page").classList.add("no-pointer");
			setShowSubMsg(true);
		} else {
			document.getElementById("page").classList.remove("no-pointer");
			setShowSubMsg(false);
		}
	}

	const handleFoodChange = (selectedOption) => {
		let foodId = selectedOption.value;
		let foodName = selectedOption.label;
		let slug = "";
		if (subscriberFoods.includes(foodId) && !accessibleFoods.includes(foodId)) {
			subscribePopupMsg(true);
		} else {
			foodList.map((food, index) => {
				if (food.foodId === foodId) {
					slug = food.slug;
					return;
				}
			});
			navigate('/foods/' + slug, { replace: true });
			navigate(0);
		}
	};

     const handleFoodScroll=() => {
      const offset=window.scrollY;
      if(offset > 110 ){
        setScrollTop(offset - defaultTop) ;
      } else{
        setScrollTop(0) ;
      }
    }
   
	return (<aside id="sidebars" style={{top : scrollTop+'px'}}>
		<section id="sidebar">
			<div className="page-inner">
				{foodLoaded && (<Select
					name="food"
					onChange={handleFoodChange}
					options={foodOptions}
                    defaultValue={{label :defaultFoodName, value :defaultFoodId}}
					isSearchable={true}
					className="myselect"
					styles={foodStyles}
				/>
				)}
			</div>
			<div className="profile_image_container">
				<img src={thisBaseURL + photoFilePath} alt={photoFileName} />
			</div>
			<div className="tabs" role="navigation">
				<ul className="menu">
						<li>
							<a href={thisBaseURL +"/foods/" +defaultSlug+"#product_uses"}>Product Uses</a>
						</li>
						<li>
							<a href={thisBaseURL +"/foods/" +defaultSlug+"#food_product_codes"}>Food Product Codes</a>
						</li>
						<li>
							<a href={thisBaseURL +"/foods/" +defaultSlug+"#standards_and_grades"}>Standards and Grades</a>
						</li>
						<li>
							<a href={thisBaseURL +"/foods/" +defaultSlug+"#consumption_production_and_trade"}>Consumption, Production and Trade</a>
						</li>
						<li>
							<a href={thisBaseURL +"/foods/" +defaultSlug+"#processing_and_supply_chain_characteristics"}>Processing and Supply Chain Characteristics</a>
						</li>
						<li>
							<a href={thisBaseURL +"/foods/" +defaultSlug+"#food_safety_and_defense"}>Food Safety and Defense</a>
						</li>
					<li className="switch_profile_item">
						<hr />
						<a href={thisBaseURL + "/countries"}>Switch to countries</a>
					</li>
				</ul>
			</div>
		</section>
		{showSubMsg && <CompanySubscriptionModal setShow={subscribePopupMsg} />}
	</aside>);

}
export default LeftMenu;